// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"gyrw4BQpOsveRq2tqc8cVg=="};